// extracted by mini-css-extract-plugin
module.exports = {"main-component":"marketPulseSurvey_main-component__1-TQE"};